<template>
  <b-container>
    <b-row>
      <b-col>
        <h2>Uuups! Die Seite konnte nicht gefunden werden!</h2>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {
    name: "VierNullVier"
}
</script>

<style lang="scss" scoped>
</style>
